import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
/*import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ko} from 'date-fns/esm/locale';*/
import ComboFclty from "../inputs/ComboFclty";
import ComboFireStatus from "../inputs/ComboFireStatus";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "../../layout/styles/components/date-picker.scss";

const DateFacilityFireSearchBox = ({
                                     searchParam,
                                     setSearchParam,
                                     updateList,
                                     setCurrentPage
                                   }) => {
  const onChangeStartDate = (date) => {
    setSearchParam({...searchParam, startDate: date});
  }

  const onChangeEndDate = (date) => {
    setSearchParam({...searchParam, endDate: date});
  }

  const onChangeFclty = (e) => {
    setSearchParam({...searchParam, fclty_cd: e.target.value});
  }

  const onChangeFireStatus = (e) => {
    setSearchParam({...searchParam, fire_status: e.target.value})
  }

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-md-center"}>
            <Col md={12}>
              <Row className={"text-center"}>
                <Col md={10}>
                  <Row className={"gy-2"}>

                    {/*<Col md={6} className={""}>*/}
                    <Col xxl={6} xl={12} lg={12} md={12}>
                      <Form.Group as={Row} controlId="formBasicSelectMenu">
                        <Form.Label column sm={2} className={"label pe-0"}>
                          조회기간
                        </Form.Label>
                        <Col xxl={4} xl={4} lg={4} md={9} sm={9}>
                          <DatePicker
                              onChange={onChangeStartDate}
                              value={searchParam.startDate}
                              format={searchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              // format={searchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              // maxDetail={searchParam.searchTerm === "M" ? "year" : "month"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              // maxDetail={"year"} // 월 선택기능시 적용
                              calendarType={'US'}
                              formatDay={
                                (locale, date) => new Intl.DateTimeFormat(
                                    'en-US',
                                    {
                                      day: "numeric"
                                    }).format(date)
                              }
                          />
                        </Col>
                        <Form.Label column sm={1} className={"label"}>
                          ~
                        </Form.Label>
                        <Col xxl={4} xl={4} lg={4} md={9} sm={9}>
                          <DatePicker
                              onChange={onChangeEndDate}
                              value={searchParam.endDate}
                              format={searchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              // maxDetail={"year"} // 월 선택기능시 적용
                              calendarType={'US'}
                              formatDay={
                                (locale, date) => new Intl.DateTimeFormat(
                                    'en-US',
                                    {
                                      day: "numeric"
                                    }).format(date)
                              }
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={6}>
                      <ComboFclty
                          propOnChange={onChangeFclty}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={6}>
                      <ComboFireStatus
                          propDefault={'화재발생'}
                          propOnChange={onChangeFireStatus}
                          propValue={searchParam.fire_status}
                          propLocation={'SEARCH'}
                      />
                    </Col>
                  </Row>
                </Col>

                {/*<Col md={2} className={"text-center"}>
                  <Button type={"submit"} className={"search-btn px-5"}>
                    검색
                  </Button>
                </Col>*/}

                <Col md={2}
                     className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                  <Button
                      type="submit"
                      className={"search-btn"}
                      style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>

              </Row>
            </Col>
          </Row>
        </Form>
      </>
  )
      ;
};

export default DateFacilityFireSearchBox;
